<template>
  <div>
    <!-- Pagination -->
    <div class="row">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">S/N</th>
                <th
                  class="school-col"
                  v-if="tokenObj.UserType == userTypeMainAdmin"
                >
                  <button class="btn p-0" @click="setSortBy('school')">
                    School
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'school'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'school_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="class-col">
                  <button class="btn p-0" @click="setSortBy('class')">
                    Class
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'class'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'class_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="name-col">
                  <button class="btn p-0" @click="setSortBy('student')">
                    Student
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'student'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'student_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="name-col">
                  <button class="btn p-0" @click="setSortBy('instructor')">
                    Instructor
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'instructor'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'instructor_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="date-col">
                  <button class="btn p-0" @click="setSortBy('date')">
                    Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'date'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'date_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="time-col">
                  <button class="btn p-0" @click="setSortBy('time')">
                    Time
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'time'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'time_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="duration-col">
                  <button class="btn p-0" @click="setSortBy('duration')">
                    Duration
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'duration'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'duration_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="date-col">
                  <button class="btn p-0" @click="setSortBy('createdDate')">
                    Created Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'createdDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'createdDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="status-col">
                  <button class="btn p-0" @click="setSortBy('status')">
                    Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'status'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'status_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in classBookings" :key="item.Id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td
                  class="school-col"
                  v-if="tokenObj.UserType == userTypeMainAdmin"
                >
                  {{ item.SchoolName }}
                </td>
                <td
                  class="class-col class-cell"
                  style="padding-top: 10px !important"
                >
                  <div style="display: flex">
                    <label class="class-title">Class Subject</label>
                    <label class="class-colon">:</label>
                    <label class="ml-2 class-content">
                      {{ item.SubjectName }}
                    </label>
                  </div>
                  <div style="display: flex">
                    <label class="class-title">Subject Level</label>
                    <label class="class-colon">:</label>
                    <label class="ml-2 class-content">
                      {{ item.SubjectLevelName }}
                    </label>
                  </div>
                  <div style="display: flex">
                    <label class="class-title">Location</label>
                    <label class="class-colon">:</label>
                    <label class="ml-2 class-content">
                      {{ item.Location }}
                    </label>
                  </div>
                  <div style="display: flex">
                    <label class="class-title">Make-up Class</label>
                    <label class="class-colon">:</label>
                    <label class="ml-2 class-content">
                      {{ item.MakeupClass }}
                    </label>
                  </div>
                </td>
                <td class="name-col">{{ item.StudentName }}</td>
                <td class="name-col">{{ item.InstructorName }}</td>
                <td class="date-col">{{ item.BookingDateDisplay }}</td>
                <td class="time-col">{{ item.BookingTime }}</td>
                <td class="duration-col">{{ item.Duration }}</td>
                <td class="date-col">{{ item.SubmittedDateDisplay }}</td>
                <td class="status-col">{{ item.Status }}</td>
                <td class="action-col">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminClassBookingShow'
                                : 'schoolAdminClassBookingShow',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="far fa-file-alt mr-2"></i>View
                      </button>
                      <button
                        v-if="item.Status != 'Cancelled'"
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminClassBookingEdit'
                                : 'schoolAdminClassBookingEdit',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="fa fa-pencil mr-2"></i>Edit
                      </button>
                      <button
                        class="dropdown-item"
                        @click="deleteClassBooking(item.Id)"
                      >
                        <i class="fa fa-trash-o mr-2"></i>Delete
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="classBookings && !classBookings.length">
                <td colspan="11" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="classBookings && classBookings.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          classBookings.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config";
export default {
  props: [
    "schoolId",
    "subjectName",
    "subjectLevelName",
    "duration",
    "makeupClass",
    "studentName",
    "instructorName",
    "startDate",
    "endDate",
    "startTimeHour",
    "startTimeMinute",
    "startTimePart",
    "endTimeHour",
    "endTimeMinute",
    "endTimePart",
    "statuses",
  ],
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      noRecordText: config.NO_RECORD_TEXT,
      classBookings: [],
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getClassBookingList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    deleteClassBooking(classBookingId) {
      let param = {
        Token: this.tokenObj.Token,
        Id: classBookingId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the class booking?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.classBooking
            .deleteClassBooking(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.paging.CurrentPage = 1;
                this.getClassBookingList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getClassBookingList() {
      let param = {
        Token: this.tokenObj.Token,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        SubjectName: this.subjectName,
        SubjectLevelName: this.subjectLevelName,
        Duration: this.duration,
        MakeupClass: this.makeupClass,
        StudentName: this.studentName,
        InstructorName: this.instructorName,
        StartDate: this.startDate,
        EndDate: this.endDate,
        StartTimeHour: this.startTimeHour,
        StartTimeMinute: this.startTimeMinute,
        StartTimePart: this.startTimePart,
        EndTimeHour: this.endTimeHour,
        EndTimeMinute: this.endTimeMinute,
        EndTimePart: this.endTimePart,
        Statuses: this.statuses,
      };
      this.$store.state.isLoading = true;
      API.classBooking
        .getClassBookingList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.classBookings = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getClassBookingList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getClassBookingList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getClassBookingList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getClassBookingList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getClassBookingList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "school":
          if (this.paging.SortBy === "school") {
            this.paging.SortBy = "school_desc";
          } else if (this.paging.SortBy === "school_desc") {
            this.paging.SortBy = "school";
          } else {
            this.paging.SortBy = "school";
          }
          break;
        case "class":
          if (this.paging.SortBy === "class") {
            this.paging.SortBy = "class_desc";
          } else if (this.paging.SortBy === "class_desc") {
            this.paging.SortBy = "class";
          } else {
            this.paging.SortBy = "class";
          }
          break;
        case "student":
          if (this.paging.SortBy === "student") {
            this.paging.SortBy = "student_desc";
          } else if (this.paging.SortBy === "student_desc") {
            this.paging.SortBy = "student";
          } else {
            this.paging.SortBy = "student";
          }
          break;
        case "instructor":
          if (this.paging.SortBy === "instructor") {
            this.paging.SortBy = "instructor_desc";
          } else if (this.paging.SortBy === "instructor_desc") {
            this.paging.SortBy = "instructor";
          } else {
            this.paging.SortBy = "instructor";
          }
          break;
        case "date":
          if (this.paging.SortBy === "date") {
            this.paging.SortBy = "date_desc";
          } else if (this.paging.SortBy === "date_desc") {
            this.paging.SortBy = "date";
          } else {
            this.paging.SortBy = "date";
          }
          break;
        case "time":
          if (this.paging.SortBy === "time") {
            this.paging.SortBy = "time_desc";
          } else if (this.paging.SortBy === "time_desc") {
            this.paging.SortBy = "time";
          } else {
            this.paging.SortBy = "time";
          }
          break;
        case "duration":
          if (this.paging.SortBy === "duration") {
            this.paging.SortBy = "duration_desc";
          } else if (this.paging.SortBy === "duration_desc") {
            this.paging.SortBy = "duration";
          } else {
            this.paging.SortBy = "duration";
          }
          break;
        case "createdDate":
          if (this.paging.SortBy === "createdDate") {
            this.paging.SortBy = "createdDate_desc";
          } else if (this.paging.SortBy === "createdDate_desc") {
            this.paging.SortBy = "createdDate";
          } else {
            this.paging.SortBy = "createdDate";
          }
          break;
        case "status":
          if (this.paging.SortBy === "status") {
            this.paging.SortBy = "status_desc";
          } else if (this.paging.SortBy === "status_desc") {
            this.paging.SortBy = "status";
          } else {
            this.paging.SortBy = "status";
          }
          break;
      }
      this.getClassBookingList();
    },
  },
  created() {
    this.getClassBookingList();
  },
};
</script>

<style scoped>
table {
  min-height: 120px;
}

.class-cell {
  font-size: 13px;
}

.class-title {
  width: 90px;
  align-items: center;
  display: flex;
}

.class-colon {
  width: 4px;
  align-items: center;
  display: flex;
}

.class-content {
  width: 150px;
  white-space: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassBookingTableFormat.vue